var Handlebars = require("../../../../../../../../../node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<button class=\"redaction-props-fill-square sq-white-w-border\" data-fill=\"WHITE_BLACK_BORDER\" title=\"White With Black Border\">\n</button>\n\n<button class=\"redaction-props-fill-square sq-black\" data-fill=\"BLACK\" title=\"Black\">\n</button>\n\n<button class=\"redaction-props-fill-square sq-white\" data-fill=\"WHITE\" title=\"White\">\n</button>\n";
},"useData":true});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/canvas/views/shape/redaction/dialog/fillSelector/template.hbs
 ** module id = 240
 ** module chunks = 0
 **/